"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var sanitizers_1 = require("./lib/sanitizers");
exports.sanitizeEmail = sanitizers_1.sanitizeEmail;
exports.sanitizePhone = sanitizers_1.sanitizePhone;
// normalizeAndSanitizePhone
exports.sanitizePII = sanitizers_1.sanitizePII;
exports.hashString = sanitizers_1.hashString;
//# sourceMappingURL=app.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/bi-logger-sanitizer/dist/src/app.js
// module id = 187
// module chunks = 0